import { render, staticRenderFns } from "./dadosgerais.vue?vue&type=template&id=68003454"
import script from "./dadosgerais.ts?vue&type=script&lang=js&external"
export * from "./dadosgerais.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68003454')) {
      api.createRecord('68003454', component.options)
    } else {
      api.reload('68003454', component.options)
    }
    module.hot.accept("./dadosgerais.vue?vue&type=template&id=68003454", function () {
      api.rerender('68003454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/importacaonfe/dadosgerais.vue"
export default component.exports